export class ClauseModel {
  description: string;
  id: number;
  provideDate: Date;
  expirationDate: Date;
  userId: number;
  deleted: boolean;
  type: number;
  subtype: number;
  tag: number;
  includeCompanyType: number;
  version: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/clause.model.ts